import { Component, EventEmitter, Input, Output } from '@angular/core';

const MIN_FONT_SIZE: number = 8;
const MAX_FONT_SIZE: number = 72;
const SIZE_UNIT: string = 'px';

@Component({
  selector: 'font-size-selector',
  template: `
    <div class="settings-segment-prop">
      <div class="settings-title">{{'COMMON.FONT_SIZE_SELECTOR.TITLE'| translate}}</div>
      <select class="settings-value" name="font-size" [(ngModel)]="fontSize" (ngModelChange)="onFontSizeChanged($event)">
        <option *ngIf="enableNoneOption" [ngValue]="null" translate>COMMON.FONT_SIZE_SELECTOR.NONE</option>
        <option *ngFor="let fontSize of fontSizes" [value]="fontSize">{{ fontSize }}</option>
      </select>
    </div>
  `,
  styles: ['']
})
export class FontSizeSelectorComponent {
  @Input() fontSize: string;
  @Input() enableNoneOption?: boolean = false;
  @Output() fontSizeChange: EventEmitter<string> = new EventEmitter<string>();

  fontSizes: string[] = [];

  constructor() {
    for(let i = MIN_FONT_SIZE; i <= MAX_FONT_SIZE; i++) {
      this.fontSizes.push(`${i}${SIZE_UNIT}`);
    }
  }

  onFontSizeChanged($event: string) {
    this.fontSizeChange.emit($event);
  }
}
